import * as ECAPI from './EcommerceService.ts';
import type { Market } from '@/domain/Market.ts';
import { fromEcapiDto } from '@/domain/assemblers/MarketAssembler.ts';
import type {
  NumberFormatDTO,
  StoreDTO
} from '@/services/generated/ECAPIStoresDTOs.ts';

export async function getMarket(
  market: string,
  channel: string,
  locale: string,
  cacheBurst?: boolean
): Promise<Market> {
  const [marketConfig, formats] = await Promise.all([
    ECAPI.stores(market, channel, cacheBurst),
    ECAPI.numberFormats(market, channel, locale, cacheBurst)
  ]);

  return fromEcapiDto(marketConfig, formats.amount);
}

export async function getMarketUsingNAPI(): Promise<Market> {
  const marketConfig = await window.napi.market().read();
  const numberFormat = {
    ...marketConfig.numberFormat,
    ...marketConfig.pricingPresentation
  } as NumberFormatDTO;

  return fromEcapiDto(marketConfig as unknown as StoreDTO, numberFormat);
}
